module.exports = __webpack_public_path__ + "static/media/mapicon.b3201cfb.png";